import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Modal from "@mui/material/Modal";
import TextField from "@mui/material/TextField";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import { Typography } from "@mui/material";
// Components
import MuiLoader from "../../components/MuiLoader";
import ContentEditor from "../../components/ContentEditor";
import ContentPreview from "../../components/ContentPreview";
import Swal from "sweetalert2";
// toastify
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// MUI
import { AppBar, Tabs, Tab } from "@mui/material";
import PropTypes from "prop-types";
// import SwipeableViews from "react-swipeable-views";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";

// MUI
import {
  Avatar,
  Button,
  InputLabel,
  FormControl,
  Select,
  Box,
  Grid,
  Card,
  CardHeader,
  IconButton,
  Menu,
  MenuItem,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import AodIcon from "@mui/icons-material/Aod";
import { red, blue, green, purple } from "@mui/material/colors";
import {
  getAllModules,
  getAllSubModules,
  getAllTopics,
  getAllContents,
  updateAllContents,
  deleteAllContents,
  createAllQuizContents,
  getAllQuizContents,
  deleteAllQuizs,
} from "./TrainingActivityThunk";

// Components
import MuiHeader from "../../components/MuiHeader";
import TemplateMaster from "../template-master/TemplateMaster";

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
};

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

const a11yProps = (index) => {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
};

const TrainingActivity = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [tabIndex, setTabIndex] = useState(0);

  const onTabChange = (event, index) => {
    setTabIndex(index);
  };

  const onTabIndexChange = (index) => {
    setTabIndex(index);
  };

  // ------------ Grid gallery view -----------
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  // ---------------------------------------------
  // --------- options for dropdowns ---------
  const language_select_option_list = [
    { value: "od", text: "ଓଡିଆ" },
    { value: "en", text: "English" },
  ];

  const usertype_select_option_list = [
    { value: "fellow", text: "Fellow" },
    { value: "anganwadi", text: "Anganwadi" },
    { value: "school", text: "School" },
  ];

  // ---------------- navigate to skillset manager -------------
  const navigate_to = () => {
    navigate("/trainingmodule");
  };
  const navigate_too = () => {
    navigate("/user-assignment");
  };
  // ------------------------------------------------------------

  const [language, setLanguage] = useState("");
  const [usertype, setUsertype] = useState("");
  const [modules, setModules] = useState([]);
  const [moduleid, setModuleid] = useState("");
  const [submodules, setSubmodules] = useState([]);
  const [submoduleid, setSubmoduleid] = useState("");
  const [topics, setTopics] = useState([]);
  const [topicid, setTopicid] = useState("");
  const [disable_content_button, setDisable_content_button] = useState(true);
  const [contentDetails, setContentDetails] = useState([]);
  const [contents, setContents] = useState([]);
  const [contentId, setContentId] = useState("");
  //console.log("contents---->", contents);
  const [quiz, setQuizs] = useState([]);
  //console.log("quiz---->", quiz);
  const [showUpdate, setShowUpdate] = useState(false);

  const [tempOpen, setTempOpen] = useState(false);

  const ITEM_HEIGHT = 48;
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [selectedSegment, setSelectedSegment] = useState({});
  const [selectedSegmentQuiz, setSelectedSegmentQuiz] = useState({});
  const [anchorEl, setAnchorEl] = useState(null);
  const openVertMenu = Boolean(anchorEl);

  // -------------- Preview -----------------------
  const [openPreview, setOpenPreview] = useState(false);
  const [previewContenttitle, setPreviewContenttitle] = useState("");
  const [previewContent, setPreviewContent] = useState("");
  //console.log("previewContent-------->", previewContent.length);

  const contentOnClick = (segment) => {
    setPreviewContenttitle(segment.displayname);
    setPreviewContent(segment.contentData);
    setOpenPreview(true);
  };

  const handleClosePreview = () => {
    setOpenPreview(false);
  };

  const openTemplateMaster = () => {
    //
    setTempOpen(true);
  };

  // ----------- create, update delete button click ----------

  const [params, setParams] = useState({});
  const create_content_button_click = () => {
    /*setOperation("save");
    setContenttitle("");
    setContentduration(0);
    setContent("");
    setIndex(-1);
    {
      contents[0].contentData && contents[0].contentData.length > 0 ? alert("Content already Created") : setOpenEditor(true);
    }
    */
    // --------------- nrusingh: modified on 28-06-2023 ---------------
    if (contents.length > 0)
      Swal.fire(
        "Error",
        "Could not create content. Content for this topic is already exists. If you still want to create a new one, please first delete the existing one.",
        "error"
      );
    else {
      const params = {
        operation: "save",
        contentfor: "taining",
        data: [],
        preferedlanguage: language,
        usertype,
        moduleid,
        submoduleid,
        topicid,
      };
      setParams(params);
      setOpenEditor(true);
    }

    // ----------------------------------------------------------------
  };

  const language_select_onchange = (event) => {
    setLanguage(event.target.value);
    setUsertype("");
    setModuleid("");
    setModules([]);
    setSubmoduleid("");
    setSubmodules([]);
    setTopicid("");
    setTopics([]);
    setContentId("");
    setContents([]);
    setQuizs([]);
    setContentDetails([]);
  };
  const usertype_select_onchange = (event) => {
    setUsertype(event.target.value);
    setModuleid("");
    setModules([]);
    setSubmoduleid("");
    setSubmodules([]);
    setTopicid("");
    setTopics([]);
    setContentId("");
    setContents([]);
    setQuizs([]);
    setContentDetails([]);
    const body = {
      usertype: event.target.value,
      language: language,
    };
    getAllModules(body).then((modules) => {
      setModules(modules.data);
    });
  };

  const module_select_onchange = (event) => {
    setModuleid(event.target.value);
    setSubmoduleid("");
    setSubmodules([]);
    setTopicid("");
    setTopics([]);
    setContentId("");
    setContents([]);
    setQuizs([]);
    setContentDetails([]);
    const body = {
      usertype: usertype,
      language: language,
      moduleid: event.target.value,
    };
    getAllSubModules(body).then((submodules) => {
      setSubmodules(submodules.data);
    });
  };

  const submodule_select_onchange = (event) => {
    setSubmoduleid(event.target.value);
    setTopicid("");
    setTopics([]);
    setContentId("");
    setContents([]);
    setQuizs([]);
    setContentDetails([]);
    const body = {
      usertype: usertype,
      language: language,
      moduleid: moduleid,
      submoduleid: event.target.value,
    };
    getAllTopics(body).then((topics) => {
      setTopics(topics.data);
    });
  };

  const topic_select_onchange = (event) => {
    setTopicid(event.target.value);
    if (event.target.value != "") {
      setDisable_content_button(false);
      getAllContents({ topicid: event.target.value }).then((content) => {
        //console.log("@@@1 content", content);
        if (Object.keys(content.data).length > 0) {
          setContentId(content.data.contentId ? content.data.contentId : "");
          setContents(content.data.contentData ? content.data.contentData : []);
          setQuizs(content.data.quizData ? content.data.quizData : []);
          setContentDetails(content.data);
        }
      });
    } else setDisable_content_button(true);
  };

  // -------------- Editor -----------------------

  const [openEditor, setOpenEditor] = useState(false);
  const [operation, setOperation] = useState("");
  const [contenttitle, setContenttitle] = useState("");
  const [content, setContent] = useState("");
  //const [contentid, setContentid] = useState();
  const [contentduration, setContentduration] = useState(0);
  const [contenttype, setContenttype] = useState("content");
  const [index, setIndex] = useState(-1);
  const [questionId, setQuestionId] = useState("");

  const handleCloseEditor = () => {
    _loaddata();
    setOpenEditor(false);
  };

  const handleVertMenuClick = (event, eachsegment, index) => {
    setAnchorEl(event.currentTarget);
    setSelectedIndex(index);
    setSelectedSegment(eachsegment);
    setSelectedSegmentQuiz(eachsegment);
  };
  const handleVertMenuClose = () => {
    setAnchorEl(null);
    setSelectedIndex(-1);
    setSelectedSegment({});
    setSelectedSegmentQuiz({});
  };

  //on update
  const update_content_button_click = () => {
    //console.log("--> contents: ", contents);
    /*
    handleVertMenuClose();
    setOperation("update");
    setContenttitle(eachsegment.topicname);
    setContent(eachsegment.contentData);
    //setContentid(eachsegment.topicid);
    setIndex(index);
    setOpenEditor(true);
    */
    // --------------- nrusingh: modified on 21-07-2023 ---------------
    if (contents.length > 0) {
      const params = {
        operation: "update",
        contentfor: "taining",
        data: contents,
        preferedlanguage: language,
        usertype,
        moduleid,
        submoduleid,
        topicid,
      };
      setParams(params);
      setOpenEditor(true);
    } else {
      Swal.fire(
        "Error",
        "Could not find content. Content for this topic is not found.",
        "error"
      );
    }
    // ----------------------------------------------------------------
  };

  const saveEditorContentData = (editor_data) => {
    setOpenEditor(false);
    if (editor_data.operation === "save") {
      //console.log(contentDetails, "contentDetails", editor_data, "editor_data");
      if (contentDetails.length > 0) {
        const data = {
          usertype: usertype,
          trainingType: "training",
          topicid: topicid,
          contentData: editor_data.content,
        };
        //console.log("data------->", data);
        updateAllContents(data).then((response) => {
          //console.log(response.data, "create training------------------->");
          if (response.data.status === "success") _loaddata();
        });
      }
    } else if (editor_data.operation === "update") {
      //console.log("editorupdate------->", editor_data.content.length);
      if (editor_data.content.length > 2) {
        const data = {
          usertype: usertype,
          trainingType: "training",
          topicid: topicid,
          contentData: editor_data.content,
        };
        //console.log("data------->", data);
        updateAllContents(data).then((response) => {
          //console.log(response.data, "create training------------------->");
          if (response.data.status === "success") _loaddata();
        });
      }
    }
  };

  //on Delete
  // const delete_content_button_click = (eachsegment, index) => {
  const delete_content_button_click = () => {
    handleVertMenuClose();
    Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this record!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      //cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        const data = {
          topicid,
          contentId,
        };
        deleteAllContents(data).then((response) => {
          //console.log("delete data response -->", response.data);
          if (response.data.status === "success") _loaddata();
        });
      }
    });
  };
  //----------------------------CReate ,update,delete quiz -----------------------//

  const [quizQuestion, setQuizQuestion] = useState("");
  const [optionA, setOptionA] = useState("");
  const [optionB, setOptionB] = useState("");
  const [optionC, setOptionC] = useState("");
  const [optionD, setOptionD] = useState("");
  const [quizAns, setQuizAns] = useState("");

  const quiz_question_select_onchange = (event) => {
    setQuizQuestion(event.target.value);
  };

  const quiz_optA_select_onchange = (event) => {
    setOptionA(event.target.value);
  };

  const quiz_optB_select_onchange = (event) => {
    setOptionB(event.target.value);
  };

  const quiz_optC_select_onchange = (event) => {
    setOptionC(event.target.value);
  };

  const quiz_optD_select_onchange = (event) => {
    setOptionD(event.target.value);
  };

  const quiz_ans_select_onchange = (event) => {
    setQuizAns(event.target.value);
  };
  const create_quiz_button_click = () => {
    setShowUpdate(true);
  };
  const handleCloseUpdate = () => {
    setShowUpdate(false);
  };

  const handleQuizSaveChanges = (editor_data) => {
    setShowUpdate(false);
    //console.log(contentDetails, "contentDetails");
    //console.log(editor_data, "editor_data");

    if (operation == "update") {
      // //console.log(operation, editor_data.target, "operation");
      // //console.log(
      //   quizQuestion,
      //   optionA,
      //   optionB,
      //   optionC,
      //   optionD,
      //   quizAns,
      //   questionId,
      //   "quizAns"
      // );
      const res = quiz.map((item) => {
        //console.log(item);
        if (item.qid == questionId) {
          item.A = optionA;
          item.B = optionB;
          item.C = optionC;
          item.D = optionD;
          item.answer = quizAns;
          item.question = quizQuestion;
        }
      });
      //console.log(quiz, "res");

      const data = {
        usertype: usertype,
        trainingType: "training",
        topicid: topicid,
        quizData: quiz,
      };
      updateAllContents(data).then((response) => {
        //console.log(response.data, "create training------------------->");
        if (response.data.status === "success") {
          _loaddata();
          setQuizQuestion("");
          setOptionA("");
          setOptionB("");
          setOptionC("");
          setOptionD("");
          setQuizAns("");
          toast.success("changes made successfully");
        }
      });
    } else {
      if (contentDetails.length > 0) {
        const data = {
          usertype: usertype,
          trainingType: "training",
          topicid: topicid,
          quizData: [
            ...contentDetails[0].quizData,
            {
              A: optionA,
              B: optionB,
              C: optionC,
              D: optionD,
              answer: quizAns,
              qid: new Date().getTime(),
              question: quizQuestion,
            },
          ],
        };
        //console.log("data------->", data);
        updateAllContents(data).then((response) => {
          //console.log(response.data, "create training------------------->");
          if (response.data.status === "success") {
            _loaddata();
            setQuizQuestion("");
            setOptionA("");
            setOptionB("");
            setOptionC("");
            setOptionD("");
            setQuizAns("");
            toast.success("changes made successfully");
          }
        });
      }
    }
  };

  const update_quiz_button_click = (eachsegment) => {
    //console.log(eachsegment, "eachsegmentjkksd on update");
    handleVertMenuClose();
    setOperation("update");
    // setContenttitle(eachsegment.displayname);
    // setContent(eachsegment.content);
    // setContentid(eachsegment.contentid);
    setQuizAns(eachsegment.answer);
    setOptionA(eachsegment.A);
    setOptionB(eachsegment.B);
    setOptionC(eachsegment.C);
    setOptionD(eachsegment.D);
    setQuizQuestion(eachsegment.question);
    setIndex(index);
    setQuestionId(eachsegment.qid);
    // setOpenEditor(true);
    setShowUpdate(true);
  };

  const delete_quiz_button_click = (eachsegment) => {
    handleVertMenuClose();
    Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this record!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      //cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        const qz = quiz.filter((item) => item.qid !== eachsegment.qid);
        const data = {
          usertype: usertype,
          trainingType: "training",
          topicid: topicid,
          quizData: qz,
        };
        //console.log(data, "delete data ------->");
        deleteAllQuizs(data).then((response) => {
          //console.log(response.data);
          if (response.data.status === "success") _loaddata();
        });
      }
    });
  };

  // ------------------- OPERATIONS ----------------------
  const _loaddata = () => {
    getAllContents({ topicid }).then((content) => {
      //console.log("@@@2 content", content);
      if (Object.keys(content.data).length > 0) {
        setContentId(content.data.contentId ? content.data.contentId : "");
        setContents(content.data.contentData ? content.data.contentData : []);
        setQuizs(content.data.quizData ? content.data.quizData : []);
        setContentDetails(content.data);
      }
    });
  };
  const _savedata = () => {};
  const _updatedata = () => {};
  const _deletedata = () => {};
  // -----------------------------------------------------
  //--------------------quiz part end------------------------------//

  return (
    <>
      <MuiHeader header="Training" />
      <div>
        <Grid container spacing={2} alignItems="center">
          <Grid item>
            <FormControl sx={{ m: 1 }} style={{ width: "130px" }} size="small">
              <InputLabel id="demo-select-small">Language</InputLabel>
              <Select
                labelId="demo-select-small"
                id="demo-select-small"
                value={language}
                label="Language"
                onChange={language_select_onchange}
              >
                <MenuItem value="">None</MenuItem>
                {language_select_option_list.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.text}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item>
            <FormControl sx={{ m: 1 }} style={{ width: "130px" }} size="small">
              <InputLabel id="demo-select-small">Usertype</InputLabel>
              <Select
                labelId="demo-select-small"
                id="demo-select-small"
                value={usertype}
                label="Language"
                onChange={usertype_select_onchange}
              >
                <MenuItem value="">None</MenuItem>
                {usertype_select_option_list.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.text}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item>
            {" "}
            <FormControl sx={{ m: 1 }} style={{ width: "130px" }} size="small">
              <InputLabel id="demo-select-small">Module</InputLabel>
              <Select
                labelId="demo-select-small"
                id="demo-select-small"
                value={moduleid}
                label="Language"
                onChange={module_select_onchange}
              >
                <MenuItem value="">None</MenuItem>
                {modules.map((option) => (
                  <MenuItem key={option.moduleid} value={option.moduleid}>
                    {option.modulename}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item>
            {" "}
            <FormControl sx={{ m: 1 }} style={{ width: "130px" }} size="small">
              <InputLabel id="demo-select-small">SubModule</InputLabel>
              <Select
                labelId="demo-select-small"
                id="demo-select-small"
                value={submoduleid}
                label="Language"
                onChange={submodule_select_onchange}
              >
                <MenuItem value="">None</MenuItem>
                {submodules.map((option) => (
                  <MenuItem key={option.submoduleid} value={option.submoduleid}>
                    {option.submodulename}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item>
            <FormControl sx={{ m: 1 }} style={{ width: "130px" }} size="small">
              <InputLabel id="demo-select-small">Topic</InputLabel>
              <Select
                labelId="demo-select-small"
                id="demo-select-small"
                value={topicid}
                label="Language"
                onChange={topic_select_onchange}
              >
                <MenuItem value="">None</MenuItem>
                {topics.map((option) => (
                  <MenuItem key={option.topicid} value={option.topicid}>
                    {option.topicname}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item>
            <Button onClick={navigate_too} variant="outlined" size="small">
              Assignment
            </Button>
          </Grid>
          <Grid item>
            <Button onClick={navigate_to} variant="outlined" size="small">
              Create Modules
            </Button>
          </Grid>
        </Grid>
      </div>
      {/* Show List */}
      <div>
        <Box sx={{ bgcolor: "background.paper", width: "100%" }}>
          <AppBar
            position="static"
            style={{ background: "#dedede", color: "black" }}
          >
            <Tabs
              value={tabIndex}
              onChange={onTabChange}
              indicatorColor="primary"
              textColor="inherit"
              variant="fullWidth"
              aria-label="full width tabs example"
            >
              <Tab label="Content" {...a11yProps(0)} />
              <Tab label="Quiz" {...a11yProps(1)} />
            </Tabs>
          </AppBar>
          <div
            axis={theme.direction === "rtl" ? "x-reverse" : "x"}
            index={tabIndex}
            onChangeIndex={onTabIndexChange}
          >
            <TabPanel value={tabIndex} index={0} dir={theme.direction}>
              {/* Content part start */}

              {/* Preview */}
              {/* update_content_button_click(selectedSegment, selectedIndex)
              delete_content_button_click(selectedSegment, selectedIndex) */}

              <Button
                onClick={create_content_button_click} //
                variant="contained"
                disabled={disable_content_button} //
              >
                Create New Content
              </Button>
              {contents && contents.length && (
                <div>
                  <Button color="error" onClick={delete_content_button_click}>
                    <HighlightOffIcon />
                  </Button>
                  <Button onClick={update_content_button_click}>
                    <DriveFileRenameOutlineIcon />
                  </Button>
                </div>
              )}

              <div className="outer-preview">
                <div className="inner-preview">
                  {contents.map((object, index) => (
                    <div key={index}>
                      <div>
                        {object.type === "text" && (
                          <>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: object.value,
                              }}
                              style={{ wordWrap: "break-word" }}
                            ></div>
                          </>
                        )}

                        {object.type === "image" && (
                          <>
                            <div>
                              <img src={object.value} width="90%" alt="" />
                            </div>
                          </>
                        )}

                        {object.type === "audio" && (
                          <>
                            <div>
                              <audio controls style={{ width: "90%" }}>
                                <source src={object.value} />
                              </audio>
                            </div>
                          </>
                        )}

                        {object.type === "video" && ( //
                          <>
                            <div style={{ marginBottom: "10px" }}>
                              <video controls width="90%">
                                <source src={object.value} />
                              </video>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Content part end */}
            </TabPanel>
            <TabPanel value={tabIndex} index={1} dir={theme.direction}>
              {/* Create Quiz Button */}
              {contents && contents.length ? (
                <Button
                  style={{ marginRight: 12 }}
                  onClick={create_quiz_button_click}
                  variant="contained"
                  // disabled={disable_content_button}
                >
                  Create New Quiz
                </Button>
              ) : null}
              {/* Quiz section start*/}
              <Card sx={{ maxWidth: 345 }} style={{ marginTop: 23 }}>
                {quiz.map((eachsegment, i) => (
                  <div key={i}>
                    <CardContent>
                      <Typography gutterBottom variant="h5" component="div">
                        {i + 1} . Question : {eachsegment.question}
                      </Typography>
                      {/* <Typography variant="body2" color="text.secondary">
               Lizards are a widespread group of squamate reptiles, with over
               6,000 species, ranging across all continents except Antarctica
             </Typography> */}
                      <div style={{ display: "flex" }}>
                        <div
                          style={{ cursor: "pointer" }}
                          // onClick={() => contentOnClick(eachsegment)}
                        >
                          A : {eachsegment.A}
                        </div>
                        <div
                          style={{ cursor: "pointer", marginLeft: 81 }}
                          // onClick={() => contentOnClick(eachsegment)}
                        >
                          B : {eachsegment.B}
                        </div>
                      </div>
                      <div style={{ display: "flex" }}>
                        <div
                          style={{ cursor: "pointer" }}
                          // onClick={() => contentOnClick(eachsegment)}
                        >
                          C : {eachsegment.C}
                        </div>
                        <div
                          style={{ cursor: "pointer", marginLeft: 80 }}
                          // onClick={() => contentOnClick(eachsegment)}
                        >
                          D : {eachsegment.D}
                        </div>
                      </div>
                      <div
                        style={{ cursor: "pointer", marginTop: 24 }}
                        // onClick={() => contentOnClick(eachsegment)}
                      >
                        Ans : {eachsegment.answer ? eachsegment.answer : ""}
                      </div>
                    </CardContent>
                    <CardActions>
                      <Button
                        size="small"
                        // onClick={() =>
                        //   update_quiz_button_click(selectedSegment, selectedIndex)
                        // }
                        onClick={() => update_quiz_button_click(eachsegment)}
                      >
                        Edit
                      </Button>
                      <Button
                        size="small"
                        onClick={() => delete_quiz_button_click(eachsegment)}
                      >
                        Delete
                      </Button>
                    </CardActions>
                  </div>
                ))}
              </Card>
              {/* Quiz section end*/}
            </TabPanel>
          </div>
        </Box>

        {/* <Box sx={{ flexGrow: 1 }} style={{ marginTop: 12 }}>
          <Grid container spacing={3}>
            {quiz.map((eachsegment, index) => (
              <Grid item xs={12} sm={isSmallScreen ? 12 : 6} md={4} key={index}>
                <Card sx={{ maxWidth: 345 }}>
                  <CardHeader
                    avatar={
                      <Avatar sx={{ bgcolor: green[500] }}>
                        <AodIcon />
                      </Avatar>
                    }
                    action={
                      <>
                        <IconButton
                          id={index + 1.1}
                          onClick={(e) =>
                            handleVertMenuClick(e, eachsegment, index)
                          }
                          aria-controls={openVertMenu ? { index } : undefined}
                          aria-expanded={openVertMenu ? "true" : undefined}
                          aria-haspopup="true">
                          <MoreVertIcon />
                        </IconButton>
                      </>
                    }
                    title={
                      <div>
                        <div
                          style={{ cursor: "pointer" }}
                          // onClick={() => contentOnClick(eachsegment)}
                        >
                          Question : {eachsegment.question}
                        </div>

                        <div style={{ display: "flex" }}>
                          <div
                            style={{ cursor: "pointer" }}
                            // onClick={() => contentOnClick(eachsegment)}
                          >
                            A : {eachsegment.A}
                          </div>
                          <div
                            style={{ cursor: "pointer", marginLeft: 81 }}
                            // onClick={() => contentOnClick(eachsegment)}
                          >
                            B : {eachsegment.B}
                          </div>
                        </div>
                        <div style={{ display: "flex" }}>
                          <div
                            style={{ cursor: "pointer" }}
                            // onClick={() => contentOnClick(eachsegment)}
                          >
                            C : {eachsegment.C}
                          </div>
                          <div
                            style={{ cursor: "pointer", marginLeft: 71 }}
                            // onClick={() => contentOnClick(eachsegment)}
                          >
                            D : {eachsegment.D}
                          </div>
                        </div>
                      </div>
                    }
                    subheader={
                      <div
                        style={{ cursor: "pointer" }}
                        onClick={() => contentOnClick(eachsegment)}>
                        Ans : {eachsegment.answer ? eachsegment.answer : ""}
                      </div>
                    }
                  />
                </Card>
              </Grid>
            ))}
            <Menu
              id={selectedIndex}
              anchorEl={anchorEl}
              open={openVertMenu}
              onClose={handleVertMenuClose}
              MenuListProps={{
                "aria-labelledby": "vert-button",
              }}
              PaperProps={{
                style: {
                  maxHeight: ITEM_HEIGHT * 4.5,
                  width: "20ch",
                },
              }}>
              <MenuItem
                onClick={() =>
                  update_quiz_button_click(selectedSegmentQuiz, selectedIndex)
                }>
                Edit
              </MenuItem>
              <MenuItem
                onClick={() =>
                  delete_quiz_button_click(selectedSegmentQuiz, selectedIndex)
                }>
                Delete
              </MenuItem>
            </Menu>
          </Grid>
        </Box> */}
      </div>

      {/* Quiz modal */}

      <Modal
        open={showUpdate}
        onClose={handleCloseUpdate}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <FormControl sx={{ m: 1, minWidth: 300 }} size="small">
            <TextField
              id="filled-basic"
              label="Objective Question"
              variant="filled"
              value={quizQuestion}
              onChange={quiz_question_select_onchange}
            />

            <Box sx={{ flexGrow: 1 }}>
              <Grid container spacing={2} style={{ marginTop: 12 }}>
                <Grid item xs={6} md={6}>
                  <TextField
                    id="outlined-basic"
                    label="Option A"
                    variant="outlined"
                    value={optionA}
                    onChange={quiz_optA_select_onchange}
                  />
                </Grid>
                <Grid item xs={6} md={6}>
                  <TextField
                    id="outlined-basic"
                    label="Option B"
                    variant="outlined"
                    value={optionB}
                    onChange={quiz_optB_select_onchange}
                  />
                </Grid>
                <Grid item xs={6} md={6}>
                  <TextField
                    id="outlined-basic"
                    label="Option C"
                    variant="outlined"
                    value={optionC}
                    onChange={quiz_optC_select_onchange}
                  />
                </Grid>
                <Grid item xs={6} md={6}>
                  <TextField
                    id="outlined-basic"
                    label="Option D"
                    variant="outlined"
                    value={optionD}
                    onChange={quiz_optD_select_onchange}
                  />
                </Grid>
              </Grid>

              <FormControl sx={{ m: 1, minWidth: 300 }} size="small">
                <InputLabel id="demo-select-small">Ans:</InputLabel>
                <Select
                  labelId="demo-select-small"
                  id="demo-select-small"
                  label="Ans"
                  value={quizAns}
                  onChange={quiz_ans_select_onchange}
                >
                  <MenuItem value="">
                    <em>Select Answer</em>
                  </MenuItem>

                  <MenuItem value="A">A</MenuItem>
                  <MenuItem value="B">B</MenuItem>
                  <MenuItem value="C">C</MenuItem>
                  <MenuItem value="D">D</MenuItem>
                </Select>
              </FormControl>
            </Box>
          </FormControl>

          <Button
            variant="outlined"
            style={{ marginLeft: 12 }}
            onClick={handleCloseUpdate}
          >
            Close
          </Button>
          <Button variant="contained" onClick={handleQuizSaveChanges}>
            SAVE
          </Button>
        </Box>
      </Modal>

      {/* Quiz modal Update*/}

      {/* <Modal
        open={showQuiz}
        onClose={handleCloseQuizUpdate}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <FormControl sx={{ m: 1, minWidth: 300 }} size="small">
            <TextField
              id="filled-basic"
              label="Objective Question"
              variant="filled"
              value={quizQuestion}
              onChange={quiz_question_select_onchange}
            />

            <Box sx={{ flexGrow: 1 }}>
              <Grid container spacing={2} style={{ marginTop: 12 }}>
                <Grid item xs={6} md={8}>
                  <TextField
                    id="outlined-basic"
                    label="Option A"
                    variant="outlined"
                    value={optionA}
                    onChange={quiz_optA_select_onchange}
                  />
                </Grid>
                <Grid item xs={6} md={4}>
                  <TextField
                    id="outlined-basic"
                    label="Option B"
                    variant="outlined"
                    value={optionB}
                    onChange={quiz_optB_select_onchange}
                  />
                </Grid>
                <Grid item xs={6} md={4}>
                  <TextField
                    id="outlined-basic"
                    label="Option C"
                    variant="outlined"
                    value={optionC}
                    onChange={quiz_optC_select_onchange}
                  />
                </Grid>
                <Grid item xs={6} md={8}>
                  <TextField
                    id="outlined-basic"
                    label="Option D"
                    variant="outlined"
                    value={optionD}
                    onChange={quiz_optD_select_onchange}
                  />
                </Grid>
              </Grid>

              <FormControl sx={{ m: 1, minWidth: 300 }} size="small">
                <InputLabel id="demo-select-small">Ans:</InputLabel>
                <Select
                  labelId="demo-select-small"
                  id="demo-select-small"
                  label="Ans"
                  value={quizAns}
                  onChange={quiz_ans_select_onchange}
                >
                  <MenuItem value="">
                    <em>Select Answer</em>
                  </MenuItem>

                  <MenuItem value="A">A</MenuItem>
                  <MenuItem value="B">B</MenuItem>
                  <MenuItem value="C">C</MenuItem>
                  <MenuItem value="D">D</MenuItem>
                </Select>
              </FormControl>
            </Box>
          </FormControl>

          <Button
            variant="outlined"
            style={{ marginLeft: 12 }}
            onClick={handleCloseQuizUpdate}
          >
            Close
          </Button>
          <Button variant="contained" onClick={handleQuizUpdate}>
            SAVE
          </Button>
        </Box>
      </Modal> */}

      {/* Editor */}
      {/* <ContentEditor open={openEditor} operation={operation} contenttitle={contenttitle} setContenttitle={setContenttitle} setContentduration={setContentduration} content={content} setContent={setContent} index={index} onSave={saveEditorContentData} onClose={handleCloseEditor} /> */}
      <TemplateMaster
        open={openEditor}
        params={params}
        onClose={handleCloseEditor}
      />

      {/* Preview */}
      <ContentPreview
        open={openPreview}
        contenttitle={previewContenttitle}
        content={previewContent}
        onClose={handleClosePreview}
      />

      {/* Loader */}
      {/* <MuiLoader open={loading} /> */}

      {/* Toaster */}
      <ToastContainer />
    </>
  );
};

export default TrainingActivity;

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
